function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaasLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14 28C14 25.1716 14 23.7574 14.8787 22.8787C15.7574 22 17.1716 22 20 22H28C30.8284 22 32.2426 22 33.1213 22.8787C34 23.7574 34 25.1716 34 28C34 30.8284 34 32.2426 33.1213 33.1213C32.2426 34 30.8284 34 28 34H20C17.1716 34 15.7574 34 14.8787 33.1213C14 32.2426 14 30.8284 14 28Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29C20.5523 29 21 28.5523 21 28C21 27.4477 20.5523 27 20 27C19.4477 27 19 27.4477 19 28C19 28.5523 19.4477 29 20 29Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 29C24.5523 29 25 28.5523 25 28C25 27.4477 24.5523 27 24 27C23.4477 27 23 27.4477 23 28C23 28.5523 23.4477 29 24 29Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 28C29 28.5523 28.5523 29 28 29C27.4477 29 27 28.5523 27 28C27 27.4477 27.4477 27 28 27C28.5523 27 29 27.4477 29 28Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 20C18.75 17.1005 21.1005 14.75 24 14.75C26.4453 14.75 28.5018 16.4224 29.0846 18.6869C29.1879 19.0881 29.5968 19.3296 29.9979 19.2263C30.3991 19.1231 30.6405 18.7142 30.5373 18.3131C29.788 15.4019 27.1463 13.25 24 13.25C20.2721 13.25 17.25 16.2721 17.25 20V22.0546C17.6865 22.022 18.1826 22.0089 18.75 22.0036V20Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaasLock);
export default __webpack_public_path__ + "static/media/baas_lock.a8f9aa5b28c9edb2fd64a307430be0be.svg";
export { ForwardRef as ReactComponent };